define('modules/lp_info/models/variant',['require','exports','module','backbone','underscore'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone"),
      _ = require("underscore");

  var defaults = {
    weight: 0,
    stats: {},
    is_main: false,
    active: true,
    id: undefined
  };

  module.exports = Backbone.Model.extend({
    initialize: function() {
      //this._save = _.debounce(this.save, 500);
      this.on("change:active", function(model, active) {
        if (this.collection) {
          this.collection.trigger("refresh", this);
        }
      });
    },
    defaults: defaults,
    createUrl: function(baseUrl) {
      var platform = this.get("mode") || "desktop",
          mode = this.get("duplicateMain") ? "copy" : "empty";
      return [baseUrl, platform, mode].join("/");
    },
    url: function() {
      var baseUrl = module.exports.__super__.url.apply(this, arguments);
      return this.isNew() ? this.createUrl(baseUrl) : baseUrl;
    },
    toJSON: function() {
      var data = module.exports.__super__.toJSON.apply(this, arguments);
      return _.omit(data, "duplicateMain", "mode", "crossPlatform", "content", "confirmation");
    },
    setWeight: function(weight, callback) {
      var safeW = Math.max(0, Math.min(100, parseInt(weight))),
          saveOptions = { patch: true, silent: true };
      if(callback){
        //we add a callback to be able to notify the user
        saveOptions.success = callback;
      }
      this.set("weight", safeW);
      this.save(null, saveOptions);
    },
    parse: function(json) {
      var variantJson = _.omit(json, ["visits", "visitors", "conversion"]);
      if (!this.initialized) {
        this.initialized = true;
      }
      return module.exports.__super__.parse.call(this, variantJson);
    },
    setAsMain: function() {
      if (this.collection) {
        this.collection.promoteToMain(this);
      }
    }
  });

});

